import axios from "axios";
import { API_URL } from "../utils/apiUtils";

export const createLoanService = async (formData) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.post(`${API_URL}/loan/create-loan`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message || "Loan Creation failed. Please try again."
    );
  }
};

export const createGroupLoanService = async (formData) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.post(
      `${API_URL}/loan/group-loan/create-loan`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message || "Loan Creation failed. Please try again."
    );
  }
};

export const getCustomerLoansService = async (id) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(
      `${API_URL}/loan/get-customer-loans/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message || "Loan fetching failed. Please try again."
    );
  }
};
export const getCustomerLoanDetailService = async (id) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(`${API_URL}/loan/get-loan-details/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data?.loan;
  } catch (error) {
    throw (
      error.response?.data?.message || "Loan fetching failed. Please try again."
    );
  }
};

export const getLoanCollectionsService = async (loanId, page, rowsPerPage) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/loan/get-customer-loan-collection`,
      {
        params: {
          loanId,
          page,
          limit: rowsPerPage, // use 'limit' for rows per page
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections"
    );
  }
};
export const getLoanCollectionService = async (loanId, isMonthly) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/loan/get-loan-collection-by-status`,
      {
        params: {
          loanId,
          isMonthly,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data?.loanCollection;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections"
    );
  }
};

export const updateLoanCollectionsService = async (
  loanId,
  amountToBePaidBy,
  collectionDate,
  interestAmount,
  paidAmount
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.put(
      `${API_URL}/loan/update-loan-collection`,
      { amountToBePaidBy, collectionDate, interestAmount, paidAmount },
      {
        params: {
          id: loanId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data?.loanCollection;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections"
    );
  }
};
export const principalCollectionsService = async (
  loanId,
  amountToBePaidBy,
  collectionDate,
  interestAmount,
  paidAmount
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.put(
      `${API_URL}/loan/collect-principal`,
      { amountToBePaidBy, collectionDate, interestAmount, paidAmount },
      {
        params: {
          id: loanId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data?.loanCollection;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections"
    );
  }
};
export const fetchTodayLoanCollections = async (page, rowsPerPage, type) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/loan/get-today-loan-collections`,

      {
        params: {
          page,
          type,
          limit: rowsPerPage, // use 'limit' for rows per page
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections"
    );
  }
};
export const fetchTodayGroupCollections = async () => {
  try {
    console.log("im called");
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/loan/group-loan/all-group-loan`,
      {
        // params: {
        //   page,
        //   limit: rowsPerPage, // use 'limit' for rows per page
        // },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections"
    );
  }
};
